import { Calendar, Trophy, Activity, Users } from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './StatsGrid.module.css';

const statsConfig = [
  { key: 'eventsJoined', label: 'Events Joined', icon: Calendar },
  { key: 'eventsHosted', label: 'Events Hosted', icon: Trophy },
  { key: 'sports', label: 'Sports', icon: Activity },
  { key: 'followers', label: 'Followers', icon: Users },
];

/**
 * StatsGrid - Glassmorphic stats dashboard
 * 
 * Features:
 * - 4-column grid of stats
 * - Animated neon numbers that count up
 * - Icon and label for each stat
 * - Hover glow effects
 */
export function StatsGrid({ stats }) {
  return (
    <div className={styles.statsContainer}>
      <div className={styles.statsGrid}>
        {statsConfig.map((stat, index) => {
          const Icon = stat.icon;
          const value = stats[stat.key];

          return (
            <div
              key={stat.key}
              className={styles.statCard}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className={styles.statIcon}>
                <Icon size={20} />
              </div>
              <span className={styles.statValue}>{value}</span>
              <Text size="xs" color="muted" className={styles.statLabel}>
                {stat.label}
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StatsGrid;
